/* ==========================================================================
   Naggat Silver — BEAT THE ROBOT | UNIQUE 9% DISCOUNT (Storefront Controller)
   - Immediate popup display on entry (never on cart or checkout pages)
   - Centralized multi-market localization (ar_EG, ar, en, fr, de, es, it) with RTL/LTR
   - Randomized starting player (X or O) & Medium tactical AI (~55-65% casual win rate)
   - 2 attempts per visitor campaign
   - Authoritative server-side unique 1-time NAG9-XXXXXX Shopify discount creation
   - First-party cookie + storage visitor persistence & idempotency
   ========================================================================== */
(function () {
  'use strict';

  if (window.__NaggatXoInitialized) { return; }
  window.__NaggatXoInitialized = true;

  var config = window.NaggatXoConfig || {};
  if (config.enabled === false) { return; }

  // Never show on checkout or cart pages
  var path = window.location.pathname || '';
  if (/^\/([a-z]{2}(-[a-z]{2})?\/)?(checkout|cart)(\/|$)/i.test(path) || config.templateName === 'cart') {
    return;
  }

  var STORAGE_KEYS = {
    VISITOR_COOKIE: 'naggat_xo_vid',
    DEVICE_SIG: 'naggat_xo_device_sig_v1',
    SESSION_CACHE: 'naggat_xo_session_v1',
    REWARD_CACHE: 'naggat_xo_reward_v1',
    SESSION_DISMISSED: 'naggat_xo_dismissed_session_v1',
    CAMPAIGN_EXHAUSTED: 'naggat_xo_exhausted_v1'
  };

  var WIN_LINES = [
    [0, 1, 2], [3, 4, 5], [6, 7, 8],
    [0, 3, 6], [1, 4, 7], [2, 5, 8],
    [0, 4, 8], [2, 4, 6]
  ];

  var ARABIC_COUNTRIES = {
    EG: 'ar_EG',
    SA: 'ar', AE: 'ar', KW: 'ar', QA: 'ar', BH: 'ar', OM: 'ar',
    JO: 'ar', LB: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', IQ: 'ar',
    LY: 'ar', SD: 'ar', YE: 'ar', SY: 'ar', PS: 'ar'
  };

  /* ---------- Centralized Localization Dictionary (Section 7) ---------- */

  var I18N = {
    en: {
      dir: 'ltr',
      brand_eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      close_label: 'Close',
      trigger_badge: 'BEAT THE ROBOT · 9% OFF',
      top_offer_banner: 'BEAT THE ROBOT — WIN 9% OFF',
      intro_headline: 'CAN YOU BEAT THE ROBOT?',
      intro_description: 'Challenge our robot in a game of XO. Win and unlock an exclusive 9% discount.',
      pill_attempts: '2 ATTEMPTS',
      pill_unique: 'UNIQUE 1-TIME CODE',
      pill_discount: '9% OFF',
      btn_play_now: 'PLAY NOW',
      btn_skip: 'SKIP',
      player_label: 'YOU',
      robot_label: 'ROBOT',
      attempt_badge: 'ATTEMPT {current} OF {max}',
      turn_player: 'Your turn (X) — select a square',
      turn_robot: 'Robot is thinking (O)...',
      board_label: 'XO Game Board',
      cell_label_empty: 'Board square {num} (empty)',
      cell_label_filled: 'Board square {num} ({symbol})',
      first_loss_msg: 'The robot got you this time! One more chance?',
      second_loss_msg: 'Almost! The robot wins this round.',
      draw_msg: "It's a draw! Try again.",
      btn_try_again: 'TRY AGAIN',
      win_headline: 'YOU BEAT THE ROBOT!',
      win_offer: 'YOU UNLOCKED 9% OFF',
      win_offer_hero: '9% OFF',
      win_description: 'Your exclusive discount is ready.',
      issuing_code: 'Generating your unique discount code...',
      code_box_label: 'YOUR UNIQUE ONE-TIME CODE',
      code_instructions: 'Apply at checkout · Valid for 1 redemption only',
      btn_copy_code: 'COPY MY DISCOUNT CODE',
      btn_code_copied: 'CODE COPIED!',
      btn_start_shopping: 'START SHOPPING',
      btn_retry_code: 'TRY AGAIN',
      btn_close: 'CLOSE',
      lose_badge: 'ROUND COMPLETE',
      lose_description: 'Explore our latest silver collection and discover your next favorite piece.',
      error_backend_unavailable: 'Temporary connection issue while generating your discount code. Please try again.'
    },
    ar_EG: {
      dir: 'rtl',
      brand_eyebrow: 'نجاة سيلفر · NAGGAT SILVER',
      close_label: 'إغلاق',
      trigger_badge: 'اتحدى الروبوت · خصم 9%',
      top_offer_banner: 'اتحدى الروبوت — واكسب خصم 9%',
      intro_headline: 'تقدر تكسب الروبوت؟',
      intro_description: 'اتحدى الروبوت في لعبة XO. لو كسبت هتفتح كود خصم حصري 9% خاص بيك لوحدك.',
      pill_attempts: 'محاولتين',
      pill_unique: 'كود شخصي لمرة واحدة',
      pill_discount: 'خصم 9%',
      btn_play_now: 'العب دلوقتي',
      btn_skip: 'تخطي',
      player_label: 'أنت',
      robot_label: 'الروبوت',
      attempt_badge: 'المحاولة {current} من {max}',
      turn_player: 'دورك أنت (X) — اختار مربع',
      turn_robot: 'الروبوت بيفكر (O)...',
      board_label: 'لوحة لعبة XO',
      cell_label_empty: 'مربع رقم {num} (فاضي)',
      cell_label_filled: 'مربع رقم {num} ({symbol})',
      first_loss_msg: 'الروبوت كسبك المرة دي! لسه قدامك فرصة تانية؟',
      second_loss_msg: 'كانت قريبة! الروبوت كسب الجولة دي.',
      draw_msg: 'تعادل! جرب تاني.',
      btn_try_again: 'جرب تاني',
      win_headline: 'كسبت الروبوت!',
      win_offer: 'فتحت خصم 9%',
      win_offer_hero: 'خصم 9%',
      win_description: 'كود الخصم الحصري بتاعك جاهز دلوقتي.',
      issuing_code: 'جاري تجهيز كود الخصم الخاص بيك...',
      code_box_label: 'كود الخصم الشخصي (يُستخدم مرة واحدة)',
      code_instructions: 'استخدم الكود عند الدفع · صالح لعملية شراء واحدة فقط',
      btn_copy_code: 'انسخ كود الخصم',
      btn_code_copied: 'تم نسخ الكود!',
      btn_start_shopping: 'ابدأ التسوق',
      btn_retry_code: 'حاول مرة تانية',
      btn_close: 'إغلاق',
      lose_badge: 'انتهت المحاولات',
      lose_description: 'استكشف أحدث كوليكشن فضة من نجاة سيلفر واختار قطعتك المفضلة.',
      error_backend_unavailable: 'حصلت مشكلة مؤقتة في الاتصال أثناء إنشاء الكود. اضغط لإعادة المحاولة.'
    },
    ar: {
      dir: 'rtl',
      brand_eyebrow: 'نجاة سيلفر · NAGGAT SILVER',
      close_label: 'إغلاق',
      trigger_badge: 'اهزم الروبوت · خصم 9%',
      top_offer_banner: 'اهزم الروبوت — واربح خصم 9%',
      intro_headline: 'هل يمكنك هزيمة الروبوت؟',
      intro_description: 'تحدَّ الروبوت في لعبة XO. الفوز يمنحك كود خصم حصري بنسبة 9% للاستخدام مرة واحدة.',
      pill_attempts: 'محاولتان',
      pill_unique: 'كود فريد لمرة واحدة',
      pill_discount: 'خصم 9%',
      btn_play_now: 'العب الآن',
      btn_skip: 'تخطي',
      player_label: 'أنت',
      robot_label: 'الروبوت',
      attempt_badge: 'المحاولة {current} من {max}',
      turn_player: 'دورك الآن (X) — اختر مربعاً',
      turn_robot: 'الروبوت يفكر (O)...',
      board_label: 'لوحة لعبة XO',
      cell_label_empty: 'المربع {num} (فارغ)',
      cell_label_filled: 'المربع {num} ({symbol})',
      first_loss_msg: 'لقد تفوق عليك الروبوت هذه المرة! هل تود فرصة أخرى؟',
      second_loss_msg: 'اقتربت كثيراً! فاز الروبوت في هذه الجولة.',
      draw_msg: 'إنها نتيجة تعادل! حاول مرة أخرى.',
      btn_try_again: 'حاول مرة أخرى',
      win_headline: 'لقد هزمت الروبوت!',
      win_offer: 'حصلت على خصم 9%',
      win_offer_hero: 'خصم 9%',
      win_description: 'كود الخصم الحصري الخاص بك جاهز الآن.',
      issuing_code: 'جارٍ إنشاء كود الخصم الفريد الخاص بك...',
      code_box_label: 'كود الخصم الفريد (لمرة واحدة)',
      code_instructions: 'يُستخدم عند إتمام الطلب · صالح لاستخدام واحد فقط',
      btn_copy_code: 'نسخ كود الخصم',
      btn_code_copied: 'تم نسخ الكود!',
      btn_start_shopping: 'ابدأ التسوق',
      btn_retry_code: 'إعادة المحاولة',
      btn_close: 'إغلاق',
      lose_badge: 'انتهت الجولة',
      lose_description: 'تصفح أحدث تشكيلة من نجاة سيلفر واكتشف قطعتك المفضلة.',
      error_backend_unavailable: 'حدث خطأ مؤقت أثناء إصدار كود الخصم. يرجى المحاولة مرة أخرى.'
    },
    fr: {
      dir: 'ltr',
      brand_eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      close_label: 'Fermer',
      trigger_badge: 'BATTEZ LE ROBOT · -9%',
      top_offer_banner: 'BATTEZ LE ROBOT — GAGNEZ 9% DE RÉDUCTION',
      intro_headline: 'POUVEZ-VOUS BATTRE LE ROBOT ?',
      intro_description: 'Défiez notre robot au jeu XO. Gagnez et débloquez une remise exclusive de 9%.',
      pill_attempts: '2 ESSAIS',
      pill_unique: 'CODE UNIQUE 1 SEUL USAGE',
      pill_discount: '-9%',
      btn_play_now: 'JOUER MAINTENANT',
      btn_skip: 'PASSER',
      player_label: 'VOUS',
      robot_label: 'ROBOT',
      attempt_badge: 'ESSAI {current} SUR {max}',
      turn_player: 'À votre tour (X) — choisissez une case',
      turn_robot: 'Le robot réfléchit (O)...',
      board_label: 'Grille de jeu XO',
      cell_label_empty: 'Case {num} (vide)',
      cell_label_filled: 'Case {num} ({symbol})',
      first_loss_msg: 'Le robot a gagné cette fois ! Une dernière chance ?',
      second_loss_msg: 'Presque ! Le robot remporte cette manche.',
      draw_msg: 'Match nul ! Réessayez.',
      btn_try_again: 'RÉESSAYER',
      win_headline: 'VOUS AVEZ BATTU LE ROBOT !',
      win_offer: 'VOUS AVEZ DÉBLOQUÉ -9%',
      win_offer_hero: '-9%',
      win_description: 'Votre remise exclusive est prête.',
      issuing_code: 'Génération de votre code promo unique...',
      code_box_label: 'VOTRE CODE UNIQUE À USAGE UNIQUE',
      code_instructions: 'À appliquer au paiement · Valable 1 seule fois',
      btn_copy_code: 'COPIER MON CODE PROMO',
      btn_code_copied: 'CODE COPIÉ !',
      btn_start_shopping: 'COMMENCER MES ACHATS',
      btn_retry_code: 'RÉESSAYER',
      btn_close: 'FERMER',
      lose_badge: 'PARTIE TERMINÉE',
      lose_description: 'Découvrez notre dernière collection en argent.',
      error_backend_unavailable: 'Erreur temporaire lors de la création de votre code. Veuillez réessayer.'
    },
    de: {
      dir: 'ltr',
      brand_eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      close_label: 'Schließen',
      trigger_badge: 'BESIEGE DEN ROBOTER · 9% RABATT',
      top_offer_banner: 'BESIEGE DEN ROBOTER — GEWINNE 9% RABATT',
      intro_headline: 'KANNST DU DEN ROBOTER SCHLAGEN?',
      intro_description: 'Fordere unseren Roboter in einer Runde XO heraus. Gewinne und sichere dir 9% Rabatt.',
      pill_attempts: '2 VERSUCHE',
      pill_unique: 'EINMALIGER CODE',
      pill_discount: '9% RABATT',
      btn_play_now: 'JETZT SPIELEN',
      btn_skip: 'ÜBERSPRINGEN',
      player_label: 'DU',
      robot_label: 'ROBOTER',
      attempt_badge: 'VERSUCH {current} VON {max}',
      turn_player: 'Du bist dran (X) — wähle ein Feld',
      turn_robot: 'Roboter überlegt (O)...',
      board_label: 'XO-Spielfeld',
      cell_label_empty: 'Spielfeld {num} (leer)',
      cell_label_filled: 'Spielfeld {num} ({symbol})',
      first_loss_msg: 'Der Roboter hat dich diesmal erwischt! Noch eine Chance?',
      second_loss_msg: 'Fast geschafft! Der Roboter gewinnt diese Runde.',
      draw_msg: 'Unentschieden! Versuche es noch einmal.',
      btn_try_again: 'NOCHMAL VERSUCHEN',
      win_headline: 'DU HAST DEN ROBOTER BESIEGT!',
      win_offer: 'DU HAST 9% RABATT FREIGESCHALTET',
      win_offer_hero: '9% RABATT',
      win_description: 'Dein exklusiver Rabattcode ist bereit.',
      issuing_code: 'Dein persönlicher Rabattcode wird erstellt...',
      code_box_label: 'DEIN EINMALIGER RABATTCODE',
      code_instructions: 'An der Kasse einlösen · Nur 1× gültig',
      btn_copy_code: 'MEINEN RABATTCODE KOPIEREN',
      btn_code_copied: 'CODE KOPIERT!',
      btn_start_shopping: 'JETZT SHOPPEN',
      btn_retry_code: 'ERNEUT VERSUCHEN',
      btn_close: 'SCHLIESSEN',
      lose_badge: 'RUNDE BEENDET',
      lose_description: 'Entdecke unsere aktuelle Silberkollektion.',
      error_backend_unavailable: 'Vorübergehender Verbindungsfehler. Bitte versuche es erneut.'
    },
    es: {
      dir: 'ltr',
      brand_eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      close_label: 'Cerrar',
      trigger_badge: 'VENCE AL ROBOT · 9% DTO.',
      top_offer_banner: 'VENCE AL ROBOT — GANA UN 9% DE DESCUENTO',
      intro_headline: '¿PUEDES VENCER AL ROBOT?',
      intro_description: 'Desafía a nuestro robot en un juego de XO. Gana y desbloquea un 9% de descuento exclusivo.',
      pill_attempts: '2 INTENTOS',
      pill_unique: 'CÓDIGO ÚNICO DE 1 USO',
      pill_discount: '9% DTO.',
      btn_play_now: 'JUGAR AHORA',
      btn_skip: 'OMITIR',
      player_label: 'TÚ',
      robot_label: 'ROBOT',
      attempt_badge: 'INTENTO {current} DE {max}',
      turn_player: 'Tu turno (X) — elige una casilla',
      turn_robot: 'El robot está pensando (O)...',
      board_label: 'Tablero de juego XO',
      cell_label_empty: 'Casilla {num} (vacía)',
      cell_label_filled: 'Casilla {num} ({symbol})',
      first_loss_msg: '¡El robot te ganó esta vez! ¿Una oportunidad más?',
      second_loss_msg: '¡Casi! El robot gana esta ronda.',
      draw_msg: '¡Es un empate! Inténtalo de nuevo.',
      btn_try_again: 'INTENTAR DE NUEVO',
      win_headline: '¡VENCISTE AL ROBOT!',
      win_offer: 'DESBLOQUEASTE 9% DE DESCUENTO',
      win_offer_hero: '9% DTO.',
      win_description: 'Tu descuento exclusivo está listo.',
      issuing_code: 'Generando tu código de descuento único...',
      code_box_label: 'TU CÓDIGO ÚNICO DE UN SOLO USO',
      code_instructions: 'Aplícalo al pagar · Válido para 1 solo uso',
      btn_copy_code: 'COPIAR MI CÓDIGO DE DESCUENTO',
      btn_code_copied: '¡CÓDIGO COPIADO!',
      btn_start_shopping: 'EMPEZAR A COMPRAR',
      btn_retry_code: 'REINTENTAR',
      btn_close: 'CERRAR',
      lose_badge: 'RONDA TERMINADA',
      lose_description: 'Explora nuestra última colección de plata.',
      error_backend_unavailable: 'Error temporal al generar tu código. Por favor, inténtalo de nuevo.'
    },
    it: {
      dir: 'ltr',
      brand_eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      close_label: 'Chiudi',
      trigger_badge: 'BATTI IL ROBOT · SCONTO 9%',
      top_offer_banner: 'BATTI IL ROBOT — VINCI IL 9% DI SCONTO',
      intro_headline: 'RIESCI A BATTERE IL ROBOT?',
      intro_description: 'Sfida il nostro robot a XO. Vinci e sblocca uno sconto esclusivo del 9%.',
      pill_attempts: '2 TENTATIVI',
      pill_unique: 'CODICE UNICO MONOUSO',
      pill_discount: 'SCONTO 9%',
      btn_play_now: 'GIOCA ORA',
      btn_skip: 'SALTA',
      player_label: 'TU',
      robot_label: 'ROBOT',
      attempt_badge: 'TENTATIVO {current} DI {max}',
      turn_player: 'Tocca a te (X) — scegli una casella',
      turn_robot: 'Il robot sta pensando (O)...',
      board_label: 'Griglia di gioco XO',
      cell_label_empty: 'Casella {num} (vuota)',
      cell_label_filled: 'Casella {num} ({symbol})',
      first_loss_msg: 'Il robot ti ha battuto questa volta! Un’altra possibilità?',
      second_loss_msg: 'Quasi! Il robot vince questo round.',
      draw_msg: 'È un pareggio! Riprova.',
      btn_try_again: 'RIPROVA',
      win_headline: 'HAI BATTUTO IL ROBOT!',
      win_offer: 'HAI SBLOCCATO IL 9% DI SCONTO',
      win_offer_hero: 'SCONTO 9%',
      win_description: 'Il tuo sconto esclusivo è pronto.',
      issuing_code: 'Generazione del tuo codice sconto unico...',
      code_box_label: 'IL TUO CODICE UNICO MONOUSO',
      code_instructions: 'Inseriscilo al checkout · Valido per 1 solo utilizzo',
      btn_copy_code: 'COPIA IL MIO CODICE SCONTO',
      btn_code_copied: 'CODICE COPIATO!',
      btn_start_shopping: 'INIZIA LO SHOPPING',
      btn_retry_code: 'RIPROVA',
      btn_close: 'CHIUDI',
      lose_badge: 'PARTITA CONCLUSA',
      lose_description: 'Scopri la nostra ultima collezione in argento.',
      error_backend_unavailable: 'Errore temporaneo durante la generazione del codice. Riprova.'
    }
  };

  function mapLangTagToKey(langTag, countryCode) {
    if (!langTag) { return null; }
    var lower = String(langTag).toLowerCase().trim();
    var upperCountry = String(countryCode || '').toUpperCase().trim();
    if (lower === 'ar_eg' || lower === 'ar-eg') { return 'ar_EG'; }
    if (lower.indexOf('ar') === 0) {
      return upperCountry === 'EG' ? 'ar_EG' : 'ar';
    }
    if (lower.indexOf('fr') === 0) { return 'fr'; }
    if (lower.indexOf('de') === 0) { return 'de'; }
    if (lower.indexOf('es') === 0) { return 'es'; }
    if (lower.indexOf('it') === 0) { return 'it'; }
    if (lower.indexOf('en') === 0) { return 'en'; }
    return null;
  }

  function detectCountryFallback() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz === 'Africa/Cairo') { return 'EG'; }
      if (tz === 'Asia/Riyadh') { return 'SA'; }
      if (tz === 'Asia/Dubai') { return 'AE'; }
      if (tz === 'Europe/Paris') { return 'FR'; }
      if (tz === 'Europe/Berlin') { return 'DE'; }
      if (tz === 'Europe/Madrid') { return 'ES'; }
      if (tz === 'Europe/Rome') { return 'IT'; }
    } catch (e) {}
    return '';
  }

  /**
   * Section 7 Detection Priority:
   * 1. Shopify active storefront locale (never overrides selected storefront language)
   * 2. Shopify market configuration
   * 3. Browser language preferences
   * 4. Trusted country detection as a fallback
   */
  function resolveActiveLocale(overrideLang, overrideCountry) {
    var urlMatch = window.location.search.match(/[?&](?:xo_lang|lang)=([a-zA-Z_-]+)/);
    var countryMatch = window.location.search.match(/[?&](?:xo_country|country)=([a-zA-Z]{2})/);
    var marketCountry = (overrideCountry || (countryMatch && countryMatch[1]) || config.marketCountry || detectCountryFallback() || '').toUpperCase();

    if (overrideLang || (urlMatch && urlMatch[1])) {
      var forced = mapLangTagToKey(overrideLang || urlMatch[1], marketCountry);
      if (forced) { return forced; }
    }

    // 1. Shopify active storefront locale (HTML lang attribute or Liquid request.locale.iso_code)
    var htmlLang = (document.documentElement.getAttribute('lang') || '').trim();
    var storefrontLang = htmlLang || config.storefrontLocale || '';
    var mappedStorefront = mapLangTagToKey(storefrontLang, marketCountry);
    if (mappedStorefront) {
      return mappedStorefront;
    }

    // 2. Shopify market configuration
    if (marketCountry) {
      if (ARABIC_COUNTRIES[marketCountry]) { return ARABIC_COUNTRIES[marketCountry]; }
      if (marketCountry === 'FR') { return 'fr'; }
      if (marketCountry === 'DE') { return 'de'; }
      if (marketCountry === 'ES') { return 'es'; }
      if (marketCountry === 'IT') { return 'it'; }
      if (marketCountry === 'US' || marketCountry === 'GB') { return 'en'; }
    }

    // 3. Browser language preferences
    var navLangs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < navLangs.length; i++) {
      var mappedBrowser = mapLangTagToKey(navLangs[i], marketCountry);
      if (mappedBrowser) { return mappedBrowser; }
    }

    // 4. Trusted country fallback
    var tzCountry = detectCountryFallback();
    if (ARABIC_COUNTRIES[tzCountry]) { return ARABIC_COUNTRIES[tzCountry]; }

    return 'en';
  }

  var activeLocaleKey = resolveActiveLocale();

  function t(key, vars) {
    var dict = I18N[activeLocaleKey] || I18N.en;
    var str = dict[key] !== undefined ? dict[key] : (I18N.en[key] || '');
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        str = str.replace(new RegExp('\\{' + k + '\\}', 'g'), String(vars[k]));
      });
    }
    return str;
  }

  /* ---------- DOM References ---------- */

  var modal = document.getElementById('XoGameModal');
  if (!modal) { return; }

  var dialog = modal.querySelector('[data-xo-dialog]');
  var triggerPill = document.getElementById('XoTriggerPill');
  var screens = {
    intro: modal.querySelector('[data-xo-screen="intro"]'),
    play: modal.querySelector('[data-xo-screen="play"]'),
    win: modal.querySelector('[data-xo-screen="win"]'),
    lose: modal.querySelector('[data-xo-screen="lose"]')
  };

  var boardEl = modal.querySelector('[data-xo-board]');
  var cells = Array.prototype.slice.call(modal.querySelectorAll('[data-xo-cell]'));
  var statusText = modal.querySelector('[data-xo-status-text]');
  var attemptsBadge = modal.querySelector('[data-xo-attempts-badge]');
  var indicatorPlayer = modal.querySelector('[data-xo-indicator-player]');
  var indicatorRobot = modal.querySelector('[data-xo-indicator-robot]');
  var roundFeedback = modal.querySelector('[data-xo-round-feedback]');
  var roundMsg = modal.querySelector('[data-xo-round-msg]');

  var issuingStateEl = modal.querySelector('[data-xo-issuing-state]');
  var claimErrorBox = modal.querySelector('[data-xo-claim-error-box]');
  var claimErrorEl = modal.querySelector('[data-xo-claim-error]');
  var rewardBox = modal.querySelector('[data-xo-reward-box]');
  var codeValueEl = modal.querySelector('[data-xo-code-value]');
  var copyBtnEl = modal.querySelector('[data-xo-copy-btn]');
  var loseHeadlineEl = modal.querySelector('[data-xo-lose-headline]');

  var lastFocusedElement = null;

  /* Central Timer & Animation Management (prevents lag, ghost timers, and stale callbacks) */
  var activeTimers = [];
  var activeRafId = null;

  function safeTimeout(fn, delay) {
    var id = setTimeout(function () {
      var idx = activeTimers.indexOf(id);
      if (idx !== -1) { activeTimers.splice(idx, 1); }
      fn();
    }, delay);
    activeTimers.push(id);
    return id;
  }

  function clearAllTimers() {
    while (activeTimers.length > 0) {
      clearTimeout(activeTimers.pop());
    }
    if (activeRafId) {
      if (typeof cancelAnimationFrame === 'function') {
        cancelAnimationFrame(activeRafId);
      } else {
        clearTimeout(activeRafId);
      }
      activeRafId = null;
    }
  }

  var state = {
    sessionId: null,
    sessionToken: null,
    winProofToken: null,
    board: ['', '', '', '', '', '', '', '', ''],
    turn: 'X',
    startingPlayer: 'X',
    isLocked: false,
    attemptNumber: 1,
    maxAttempts: Number(config.maxAttempts) || 2,
    status: 'idle', // idle | playing | round_over | won | lost | rewarded
    lastLossType: 'loss', // loss | draw
    idempotencyKey: null,
    issuedCode: null
  };

  /* ---------- First-Party Cookie + LocalStorage Visitor Persistence ---------- */

  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    try {
      var maxAge = (days || 365) * 24 * 60 * 60;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }

  function getStorage(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setStorage(key, val) {
    try {
      window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }

  function getSessionFlag(key) {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function setSessionFlag(key) {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (e) {}
  }

  function getVisitorSignature() {
    var cookieId = getCookie(STORAGE_KEYS.VISITOR_COOKIE);
    var stored = getStorage(STORAGE_KEYS.DEVICE_SIG);
    var id = cookieId || (stored && stored.id) || null;
    if (!id) {
      id = 'nxo_' + Date.now().toString(36) + '_' + Math.random().toString(36).substring(2, 12);
    }
    setCookie(STORAGE_KEYS.VISITOR_COOKIE, id, 365);
    if (!stored || stored.id !== id) {
      setStorage(STORAGE_KEYS.DEVICE_SIG, { id: id, createdAt: Date.now() });
    }
    return id;
  }

  /* ---------- Localization Application ---------- */

  function applyLocalization(localeOverride, countryOverride) {
    activeLocaleKey = resolveActiveLocale(localeOverride, countryOverride);
    var dir = t('dir');
    modal.setAttribute('dir', dir);
    modal.setAttribute('data-xo-lang', activeLocaleKey);
    if (triggerPill) {
      triggerPill.setAttribute('dir', dir);
    }

    var textNodes = modal.querySelectorAll('[data-xo-i18n]');
    for (var i = 0; i < textNodes.length; i++) {
      var el = textNodes[i];
      var key = el.getAttribute('data-xo-i18n');
      if (key) {
        el.textContent = t(key);
      }
    }
    if (triggerPill) {
      var pillText = triggerPill.querySelector('[data-xo-i18n="trigger_badge"]');
      if (pillText) { pillText.textContent = t('trigger_badge'); }
    }

    var ariaNodes = modal.querySelectorAll('[data-xo-i18n-aria]');
    for (var j = 0; j < ariaNodes.length; j++) {
      var aEl = ariaNodes[j];
      var aKey = aEl.getAttribute('data-xo-i18n-aria');
      if (aKey) {
        aEl.setAttribute('aria-label', t(aKey));
      }
    }

    if (attemptsBadge) {
      attemptsBadge.textContent = t('attempt_badge', {
        current: state.attemptNumber,
        max: state.maxAttempts
      });
    }

    if (statusText && state.status === 'playing') {
      statusText.textContent = state.turn === 'X' ? t('turn_player') : t('turn_robot');
    }

    renderBoard();
  }

  /* ---------- Analytics Tracking (Section 10) ---------- */

  var analyticsHistory = [];

  function trackEvent(eventName, payload) {
    var data = Object.assign({
      event: eventName,
      timestamp: new Date().toISOString(),
      sessionId: state.sessionId,
      attemptNumber: state.attemptNumber,
      locale: activeLocaleKey,
      page: window.location.pathname
    }, payload || {});

    analyticsHistory.push(data);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('naggat_xo_' + eventName, data);
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'naggat_xo_' + eventName }, data));
      }
      window.dispatchEvent(new CustomEvent('naggat:xo_analytics', { detail: data }));
    } catch (e) {}

    var apiBase = (config.apiEndpoint || '').replace(/\/$/, '');
    if (apiBase) {
      var body = JSON.stringify({
        eventType: eventName,
        sessionId: state.sessionId,
        deviceSignature: getVisitorSignature(),
        metadata: payload || {}
      });
      try {
        if (navigator.sendBeacon) {
          var blob = new Blob([body], { type: 'application/json' });
          navigator.sendBeacon(apiBase + '/api/xo/analytics', blob);
        } else {
          fetch(apiBase + '/api/xo/analytics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body,
            keepalive: true
          }).catch(function () {});
        }
      } catch (e) {}
    }
  }

  /* ---------- Backend API Client ---------- */

  function apiRequest(pathUrl, payload) {
    var apiBase = (config.apiEndpoint || '').replace(/\/$/, '');
    if (!apiBase) {
      return Promise.reject(new Error('Backend API endpoint not configured.'));
    }
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = controller ? setTimeout(function () { controller.abort(); }, 9000) : null;

    return fetch(apiBase + pathUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.assign({
        deviceSignature: getVisitorSignature(),
        shopDomain: config.shopDomain,
        customerId: config.customer ? config.customer.id : null,
        email: config.customer ? config.customer.email : null,
        phone: config.customer ? config.customer.phone : null
      }, payload || {})),
      signal: controller ? controller.signal : undefined
    }).then(function (res) {
      if (timeoutId) { clearTimeout(timeoutId); }
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.error) || 'Request failed');
          err.code = data && data.code;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- Mathematically Optimal Unbeatable AI (Minimax + Alpha-Beta Pruning) ---------- */

  function checkQuickWinner(b) {
    if (b[0] && b[0] === b[1] && b[1] === b[2]) return b[0];
    if (b[3] && b[3] === b[4] && b[4] === b[5]) return b[3];
    if (b[6] && b[6] === b[7] && b[7] === b[8]) return b[6];
    if (b[0] && b[0] === b[3] && b[3] === b[6]) return b[0];
    if (b[1] && b[1] === b[4] && b[4] === b[7]) return b[1];
    if (b[2] && b[2] === b[5] && b[5] === b[8]) return b[2];
    if (b[0] && b[0] === b[4] && b[4] === b[8]) return b[0];
    if (b[2] && b[2] === b[4] && b[4] === b[6]) return b[2];
    return null;
  }

  function evaluateBoard(board) {
    for (var i = 0; i < WIN_LINES.length; i++) {
      var line = WIN_LINES[i];
      var a = board[line[0]];
      var b = board[line[1]];
      var c = board[line[2]];
      if (a && a === b && a === c) {
        return { status: a === 'X' ? 'player_won' : 'robot_won', line: line };
      }
    }
    var hasEmpty = false;
    for (var j = 0; j < 9; j++) {
      if (!board[j]) { hasEmpty = true; break; }
    }
    return { status: hasEmpty ? 'ongoing' : 'draw', line: null };
  }

  function evaluateMinimax(board, depth, isMaximizing, alpha, beta) {
    var winner = checkQuickWinner(board);
    if (winner === 'O') return 10 - depth;
    if (winner === 'X') return depth - 10;

    var hasEmpty = false;
    for (var i = 0; i < 9; i++) {
      if (!board[i]) { hasEmpty = true; break; }
    }
    if (!hasEmpty) return 0;

    alpha = alpha !== undefined ? alpha : -100;
    beta = beta !== undefined ? beta : 100;

    if (isMaximizing) {
      var maxEval = -100;
      for (var m = 0; m < 9; m++) {
        if (!board[m]) {
          board[m] = 'O';
          var ev = evaluateMinimax(board, depth + 1, false, alpha, beta);
          board[m] = '';
          if (ev > maxEval) maxEval = ev;
          if (ev > alpha) alpha = ev;
          if (beta <= alpha) break;
        }
      }
      return maxEval;
    } else {
      var minEval = 100;
      for (var n = 0; n < 9; n++) {
        if (!board[n]) {
          board[n] = 'X';
          var evMin = evaluateMinimax(board, depth + 1, true, alpha, beta);
          board[n] = '';
          if (evMin < minEval) minEval = evMin;
          if (evMin < beta) beta = evMin;
          if (beta <= alpha) break;
        }
      }
      return minEval;
    }
  }

  function computeOptimalRobotMove(board) {
    var emptySquares = [];
    for (var i = 0; i < 9; i++) {
      if (!board[i]) { emptySquares.push(i); }
    }
    if (emptySquares.length === 0) { return -1; }

    // If whole board is empty, take center
    if (emptySquares.length === 9) { return 4; }

    // 1. Immediate Win: take winning move directly
    for (var w = 0; w < emptySquares.length; w++) {
      var wIdx = emptySquares[w];
      board[wIdx] = 'O';
      if (checkQuickWinner(board) === 'O') {
        board[wIdx] = '';
        return wIdx;
      }
      board[wIdx] = '';
    }

    // 2. Immediate Block: block opponent's winning threat directly
    for (var b = 0; b < emptySquares.length; b++) {
      var bIdx = emptySquares[b];
      board[bIdx] = 'X';
      if (checkQuickWinner(board) === 'X') {
        board[bIdx] = '';
        return bIdx;
      }
      board[bIdx] = '';
    }

    // 3. Optimal Minimax calculation with alpha-beta pruning (100% Unbeatable)
    var bestScore = -1000;
    var bestMoves = [];

    for (var k = 0; k < emptySquares.length; k++) {
      var idx = emptySquares[k];
      board[idx] = 'O';
      var score = evaluateMinimax(board, 0, false, -100, 100);
      board[idx] = '';

      if (score > bestScore) {
        bestScore = score;
        bestMoves = [idx];
      } else if (score === bestScore) {
        bestMoves.push(idx);
      }
    }

    if (bestMoves.indexOf(4) !== -1) { return 4; }
    var cornerPicks = bestMoves.filter(function (m) {
      return m === 0 || m === 2 || m === 6 || m === 8;
    });
    if (cornerPicks.length > 0) {
      return cornerPicks[0];
    }

    return bestMoves[0];
  }

  var computeMediumRobotMove = computeOptimalRobotMove;

  /* ---------- High-Performance UI Screen & Board Rendering ---------- */

  function showScreen(screenKey) {
    Object.keys(screens).forEach(function (key) {
      var el = screens[key];
      if (!el) { return; }
      if (key === screenKey) {
        el.hidden = false;
        el.classList.add('is-active');
      } else {
        el.hidden = true;
        el.classList.remove('is-active');
      }
    });
  }

  function updateCellDOM(idx, val, isWin) {
    var cell = cells[idx];
    if (!cell) { return; }
    var currentVal = cell.getAttribute('data-symbol') || '';
    if (currentVal !== val) {
      cell.textContent = val;
      cell.setAttribute('data-symbol', val);
      cell.setAttribute(
        'aria-label',
        val
          ? t('cell_label_filled', { num: idx + 1, symbol: val })
          : t('cell_label_empty', { num: idx + 1 })
      );
    }
    var shouldDisable = Boolean(val) || state.isLocked || state.turn !== 'X' || state.status !== 'playing';
    if (cell.disabled !== shouldDisable) {
      cell.disabled = shouldDisable;
    }
    var isWinBool = Boolean(isWin);
    if (cell.classList.contains('is-win') !== isWinBool) {
      cell.classList.toggle('is-win', isWinBool);
    }
  }

  function updateCellsDisabledState() {
    for (var i = 0; i < 9; i++) {
      var cell = cells[i];
      if (!cell) continue;
      var val = state.board[i] || '';
      var shouldDisable = Boolean(val) || state.isLocked || state.turn !== 'X' || state.status !== 'playing';
      if (cell.disabled !== shouldDisable) {
        cell.disabled = shouldDisable;
      }
    }
  }

  function renderFullBoard(winLine) {
    for (var i = 0; i < 9; i++) {
      var isWin = Array.isArray(winLine) && winLine.indexOf(i) !== -1;
      updateCellDOM(i, state.board[i] || '', isWin);
    }

    if (indicatorPlayer && indicatorRobot) {
      indicatorPlayer.classList.toggle('is-active', state.turn === 'X');
      indicatorRobot.classList.toggle('is-active', state.turn === 'O');
    }
    if (attemptsBadge) {
      attemptsBadge.textContent = t('attempt_badge', {
        current: state.attemptNumber,
        max: state.maxAttempts
      });
    }
  }

  var renderBoard = renderFullBoard;

  function displayIssuedDiscountCode(codeStr) {
    state.status = 'rewarded';
    state.issuedCode = codeStr;
    if (issuingStateEl) { issuingStateEl.hidden = true; }
    if (claimErrorBox) { claimErrorBox.hidden = true; }
    if (rewardBox) { rewardBox.hidden = false; }
    if (codeValueEl) { codeValueEl.textContent = codeStr; }
    if (copyBtnEl) { copyBtnEl.textContent = t('btn_copy_code'); }
    showScreen('win');
  }

  function openModal(source) {
    window.__NaggatXoActive = true;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-modal');
    if (triggerPill) { triggerPill.hidden = true; }

    lastFocusedElement = document.activeElement;

    // Preserve winning state & retrieve existing code if already issued to this visitor
    var cachedReward = getStorage(STORAGE_KEYS.REWARD_CACHE);
    if (cachedReward && cachedReward.code) {
      displayIssuedDiscountCode(cachedReward.code);
    } else if (state.status === 'won') {
      showScreen('win');
    } else if (state.status === 'lost' || getStorage(STORAGE_KEYS.CAMPAIGN_EXHAUSTED)) {
      showScreen('lose');
    }

    trackEvent('popup_displayed', { source: source || 'entry' });
    if (dialog) { dialog.focus(); }
  }

  function hasFinishedAllAttemptsOrWon() {
    var cachedReward = getStorage(STORAGE_KEYS.REWARD_CACHE);
    var exhausted = getStorage(STORAGE_KEYS.CAMPAIGN_EXHAUSTED);
    return Boolean(
      state.status === 'won' ||
      state.status === 'rewarded' ||
      state.status === 'lost' ||
      (cachedReward && cachedReward.code) ||
      exhausted
    );
  }

  function syncTriggerPillVisibility() {
    if (!triggerPill) { return; }
    if (modal.classList.contains('is-open') || hasFinishedAllAttemptsOrWon()) {
      triggerPill.hidden = true;
      triggerPill.style.display = 'none';
    } else {
      triggerPill.hidden = false;
      triggerPill.style.display = '';
    }
  }

  function closeModal(reason) {
    clearAllTimers();
    window.__NaggatXoActive = false;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-modal');
    syncTriggerPillVisibility();

    setSessionFlag(STORAGE_KEYS.SESSION_DISMISSED);

    if (reason === 'skip') {
      trackEvent('skip_clicked');
    }
    trackEvent('popup_dismissed', { reason: reason || 'close' });

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }

    try {
      window.dispatchEvent(new CustomEvent('naggat:xo_onboarding_completed', {
        detail: {
          reason: reason || 'close',
          status: state.status,
          reward: getStorage(STORAGE_KEYS.REWARD_CACHE)
        }
      }));
    } catch (e) {}
  }

  /* ---------- Authoritative Discount Issuance (Section 2, 3, 5) ---------- */

  function requestUniqueDiscountCode() {
    var cachedReward = getStorage(STORAGE_KEYS.REWARD_CACHE);
    if (cachedReward && cachedReward.code) {
      displayIssuedDiscountCode(cachedReward.code);
      return Promise.resolve(cachedReward);
    }

    if (issuingStateEl) { issuingStateEl.hidden = false; }
    if (claimErrorBox) { claimErrorBox.hidden = true; }
    if (rewardBox) { rewardBox.hidden = true; }

    if (!state.idempotencyKey) {
      state.idempotencyKey = 'win_' + (state.sessionId || getVisitorSignature()) + '_' + state.attemptNumber;
    }

    trackEvent('discount_generation_requested', {
      sessionId: state.sessionId,
      idempotencyKey: state.idempotencyKey
    });

    return apiRequest('/api/xo/claim', {
      sessionId: state.sessionId,
      sessionToken: state.sessionToken,
      winProofToken: state.winProofToken,
      board: state.board,
      attemptNumber: state.attemptNumber,
      idempotencyKey: state.idempotencyKey,
      customerId: (config.customer && config.customer.id) || null,
      email: (config.customer && config.customer.email) || null,
      phone: (config.customer && config.customer.phone) || null
    }).then(function (res) {
      if (!res || !res.code) {
        throw new Error(t('error_backend_unavailable'));
      }
      var rewardRecord = {
        code: res.code,
        discountPercent: res.discountPercent || config.discountPercent || 9,
        issuedAt: res.issuedAt || new Date().toISOString(),
        expiresAt: res.expiresAt || null
      };
      setStorage(STORAGE_KEYS.REWARD_CACHE, rewardRecord);
      displayIssuedDiscountCode(rewardRecord.code);
      trackEvent('discount_generation_successful', {
        code: rewardRecord.code,
        idempotentReplay: Boolean(res.idempotentReplay)
      });
      return rewardRecord;
    }).catch(function (err) {
      // Section 5 & TEST 14: Keep winning state, never show a fake code, allow secure retry
      if (issuingStateEl) { issuingStateEl.hidden = true; }
      if (rewardBox) { rewardBox.hidden = true; }
      if (claimErrorBox) { claimErrorBox.hidden = false; }
      if (claimErrorEl) {
        claimErrorEl.textContent = t('error_backend_unavailable');
      }
      trackEvent('discount_generation_failed', {
        message: (err && err.message) || 'Backend error'
      });
    });
  }

  /* ---------- Session Initialization & Gameplay ---------- */

  function startSessionAndPlay() {
    var cachedReward = getStorage(STORAGE_KEYS.REWARD_CACHE);
    if (cachedReward && cachedReward.code) {
      displayIssuedDiscountCode(cachedReward.code);
      return;
    }

    var exhausted = getStorage(STORAGE_KEYS.CAMPAIGN_EXHAUSTED);
    if (exhausted && exhausted.at && (Date.now() - exhausted.at < 24 * 3600 * 1000)) {
      state.status = 'lost';
      showScreen('lose');
      return;
    }

    // 100% Local, Instant Game Initialization (Zero network requests / Zero delay)
    clearAllTimers();
    state.sessionId = 'xo_' + (getVisitorSignature() || 'guest') + '_' + Date.now().toString(36);
    state.sessionToken = 'local_' + Math.random().toString(36).substring(2, 9);
    state.attemptNumber = 1;
    state.maxAttempts = config.maxAttempts || 2;
    state.startingPlayer = 'X';
    state.board = ['', '', '', '', '', '', '', '', ''];
    state.turn = 'X';
    state.isLocked = false;
    state.status = 'playing';

    if (roundFeedback) { roundFeedback.hidden = true; }
    if (statusText) { statusText.textContent = t('turn_player'); }
    renderFullBoard();
    showScreen('play');
    trackEvent('game_started', { startingPlayer: 'X' });
  }

  function handleRoundOutcome(evalResult, serverProofToken) {
    state.isLocked = true;
    clearAllTimers();

    var isDraw = evalResult.status === 'draw';
    var isPlayerWin = evalResult.status === 'player_won';

    // Highlight winning line if winner exists
    if (Array.isArray(evalResult.line)) {
      renderFullBoard(evalResult.line);
    } else {
      renderFullBoard();
    }
    updateCellsDisabledState();

    if (isPlayerWin) {
      state.status = 'won';
      state.winProofToken = serverProofToken || state.winProofToken;
      trackEvent('player_wins', { attempt: state.attemptNumber });

      safeTimeout(function () {
        showScreen('win');
        requestUniqueDiscountCode();
      }, 200);
      return;
    }

    if (isDraw) {
      trackEvent('draw', { attempt: state.attemptNumber });
    } else {
      trackEvent('robot_wins', { attempt: state.attemptNumber });
    }

    if (state.attemptNumber < state.maxAttempts) {
      state.status = 'round_over';
      if (roundMsg) {
        roundMsg.textContent = isDraw ? t('draw_msg') : t('first_loss_msg');
      }
      if (roundFeedback) {
        roundFeedback.hidden = false;
      }
      if (statusText) {
        statusText.textContent = isDraw ? t('draw_msg') : t('first_loss_msg');
      }
    } else {
      state.status = 'lost';
      setStorage(STORAGE_KEYS.CAMPAIGN_EXHAUSTED, { at: Date.now() });
      if (loseHeadlineEl) {
        loseHeadlineEl.textContent = isDraw ? t('draw_msg') : t('second_loss_msg');
      }
      safeTimeout(function () {
        showScreen('lose');
      }, 350);
    }
  }

  function scheduleRobotMove() {
    var raf = typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame
      : function (fn) { return setTimeout(fn, 16); };

    activeRafId = raf(function () {
      activeRafId = null;
      if (state.status !== 'playing' || state.turn !== 'O') { return; }

      var robotIdx = computeOptimalRobotMove(state.board);
      if (robotIdx !== -1 && !state.board[robotIdx]) {
        state.board[robotIdx] = 'O';
        updateCellDOM(robotIdx, 'O');
      }

      var afterRobot = evaluateBoard(state.board);
      if (afterRobot.status !== 'ongoing') {
        handleRoundOutcome(afterRobot, null);
      } else {
        state.turn = 'X';
        state.isLocked = false;
        if (statusText) { statusText.textContent = t('turn_player'); }
        if (indicatorPlayer && indicatorRobot) {
          indicatorPlayer.classList.add('is-active');
          indicatorRobot.classList.remove('is-active');
        }
        updateCellsDisabledState();
      }
    });
  }

  function handlePlayerMove(index) {
    // 1. Strict guard conditions: prevent occupied selection, moves during AI turn, and clicks after game end
    if (state.isLocked || state.status !== 'playing' || state.turn !== 'X') {
      return;
    }
    if (typeof index !== 'number' || index < 0 || index > 8 || state.board[index]) {
      return;
    }

    // 2. Instant Player Move Registration (0ms latency)
    state.isLocked = true;
    state.board[index] = 'X';
    updateCellDOM(index, 'X');

    // 3. Immediate Outcome Check after Player Move
    var afterPlayer = evaluateBoard(state.board);
    if (afterPlayer.status !== 'ongoing') {
      handleRoundOutcome(afterPlayer, null);
      return;
    }

    // 4. Switch HUD turn to Robot
    state.turn = 'O';
    if (statusText) {
      statusText.textContent = t('turn_robot');
    }
    if (indicatorPlayer && indicatorRobot) {
      indicatorPlayer.classList.remove('is-active');
      indicatorRobot.classList.add('is-active');
    }
    updateCellsDisabledState();

    // 5. Immediate AI Response in Next Animation Frame (Smooth 60/120fps with Zero Artificial Delay)
    scheduleRobotMove();
  }

  function startSecondAttempt() {
    if (state.attemptNumber >= state.maxAttempts) { return; }

    clearAllTimers();
    state.attemptNumber = 2;
    state.sessionId = 'xo_' + (getVisitorSignature() || 'guest') + '_' + Date.now().toString(36);
    state.sessionToken = 'local_' + Math.random().toString(36).substring(2, 9);
    state.startingPlayer = 'X';
    state.board = ['', '', '', '', '', '', '', '', ''];
    state.turn = 'X';
    state.isLocked = false;
    state.status = 'playing';

    if (roundFeedback) { roundFeedback.hidden = true; }
    if (statusText) { statusText.textContent = t('turn_player'); }
    renderFullBoard();
    showScreen('play');
    trackEvent('second_attempt_started', { startingPlayer: 'X' });
  }

  var fallbackSecondAttempt = startSecondAttempt;

  function copyDiscountCode(codeText, btnEl) {
    if (!codeText) { return; }
    var onCopied = function () {
      if (btnEl) {
        btnEl.textContent = t('btn_code_copied');
        setTimeout(function () {
          btnEl.textContent = t('btn_copy_code');
        }, 2500);
      }
      trackEvent('code_copied', { code: codeText });
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codeText).then(onCopied).catch(function () {
        fallbackCopy(codeText, onCopied);
      });
    } else {
      fallbackCopy(codeText, onCopied);
    }
  }

  function fallbackCopy(codeText, cb) {
    var temp = document.createElement('textarea');
    temp.value = codeText;
    temp.setAttribute('readonly', '');
    temp.style.position = 'fixed';
    temp.style.opacity = '0';
    document.body.appendChild(temp);
    temp.select();
    try { document.execCommand('copy'); if (cb) { cb(); } } catch (e) {}
    document.body.removeChild(temp);
  }

  /* ---------- Event Delegation ---------- */

  if (boardEl) {
    boardEl.addEventListener('click', function (e) {
      var cell = e.target.closest('[data-xo-cell]');
      if (!cell) { return; }
      e.preventDefault();
      var idx = parseInt(cell.getAttribute('data-xo-cell'), 10);
      if (!isNaN(idx)) {
        handlePlayerMove(idx);
      }
    });
  }

  modal.addEventListener('click', function (e) {
    var target = e.target;

    if (target.closest('[data-xo-skip]')) {
      e.preventDefault();
      closeModal('skip');
      return;
    }

    if (target.closest('[data-xo-close]')) {
      e.preventDefault();
      closeModal('close');
      return;
    }

    if (target.closest('[data-xo-play]')) {
      e.preventDefault();
      startSessionAndPlay();
      return;
    }

    if (!boardEl) {
      var cell = target.closest('[data-xo-cell]');
      if (cell) {
        e.preventDefault();
        var idx = parseInt(cell.getAttribute('data-xo-cell'), 10);
        if (!isNaN(idx)) {
          handlePlayerMove(idx);
        }
        return;
      }
    }

    if (target.closest('[data-xo-retry]')) {
      e.preventDefault();
      startSecondAttempt();
      return;
    }

    if (target.closest('[data-xo-retry-claim]')) {
      e.preventDefault();
      requestUniqueDiscountCode();
      return;
    }

    var copyBtn = target.closest('[data-xo-copy-btn]');
    if (copyBtn) {
      e.preventDefault();
      copyDiscountCode(codeValueEl ? codeValueEl.textContent.trim() : '', copyBtn);
      return;
    }

    if (target.closest('[data-xo-shop-now]') || target.closest('[data-xo-explore]')) {
      closeModal('start_shopping');
      return;
    }
  });

  if (triggerPill) {
    triggerPill.addEventListener('click', function (e) {
      e.preventDefault();
      openModal('trigger_pill');
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) { return; }
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal('escape');
    }
  });

  // Observe dynamic changes to <html lang="..."> so storefront language switches update RTL/LTR immediately
  if (typeof MutationObserver !== 'undefined') {
    var htmlObserver = new MutationObserver(function () {
      applyLocalization();
    });
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang', 'dir']
    });
  }

  /* ---------- Immediate Entry Display (Section 1 & Section 8) ---------- */

  function isLanguagePending() {
    // Language modal removed at beginning; XO game can display directly on entry
    return false;
  }

  function initPopup() {
    getVisitorSignature();
    applyLocalization();

    var forceOpen = /[?&]xo=1\b/i.test(window.location.search) || window.location.hash === '#xo-game';
    var dismissedThisSession = getSessionFlag(STORAGE_KEYS.SESSION_DISMISSED);

    // If visitor already won (on attempt 1 or 2) or exhausted all 2 attempts, hide the game tab & popup
    if (!forceOpen && hasFinishedAllAttemptsOrWon()) {
      syncTriggerPillVisibility();
      return;
    }

    if (!forceOpen && dismissedThisSession) {
      syncTriggerPillVisibility();
      return;
    }

    // Sequence: XO Game appears AFTER language selector!
    if (!forceOpen && isLanguagePending()) {
      var onLanguageDone = function () {
        window.removeEventListener('naggat:language_completed', onLanguageDone);
        setTimeout(function () {
          if (!hasFinishedAllAttemptsOrWon() && !getSessionFlag(STORAGE_KEYS.SESSION_DISMISSED)) {
            openModal('after_language');
          }
        }, 400);
      };
      window.addEventListener('naggat:language_completed', onLanguageDone);
      syncTriggerPillVisibility();
      return;
    }

    openModal('entry_immediate');
  }

  // Expose public controller for testing & storefront integration
  window.NaggatXoGame = {
    open: function () { openModal('manual'); },
    close: function () { closeModal('manual'); },
    triggerOnboarding: function () {
      if (!hasFinishedAllAttemptsOrWon() && !getSessionFlag(STORAGE_KEYS.SESSION_DISMISSED)) {
        openModal('after_language');
      }
    },
    setLocale: function (lang, country) { applyLocalization(lang, country); },
    getLocale: function () { return activeLocaleKey; },
    getVisitorId: getVisitorSignature,
    getState: function () { return state; },
    getAnalyticsHistory: function () { return analyticsHistory.slice(); },
    isActive: function () { return modal && modal.classList.contains('is-open'); },
    hasCompleted: function () { return hasFinishedAllAttemptsOrWon(); }
  };

  function scheduleInitPopup() {
    var forceOpen = /[?&]xo=1\b/i.test(window.location.search) || window.location.hash === '#xo-game';
    if (forceOpen) {
      initPopup();
      return;
    }
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        setTimeout(initPopup, 800);
      }, { timeout: 2500 });
    } else {
      setTimeout(initPopup, 1200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleInitPopup();
  } else {
    window.addEventListener('load', scheduleInitPopup, { once: true });
  }
})();
